<template>
    <div class="kpi-item kpi-item--warning">
        <div class="kpi-item__illustration">
            <img src="/ressources/logged/img/illustrations/kpis/empty-params.svg" :alt="label" />
        </div>
        <div class="kpi-item__content">
            <p class="kpi-item__label typographies-paragraph-medium-semibold">
                {{ label }}
            </p>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            required: true,
        },
    },
};
</script>
<style scoped lang="scss">
.kpi-item {
    align-items: center;
    display: flex;
    gap: var(--spacing-2);

    &__illustration {
        flex: 0 0 auto;
        height: 38px;
        width: 38px;
    }

    &__label {
        color: var(--colors-common-text-subtle-default);
        margin: 0;
    }
}
</style>
